exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.location-nav-link[data-v-5f4ba43e]{color:#3b3b3b\n}\n.location-nav-link[data-v-5f4ba43e]:hover{color:#007fb1\n}\n.location-nav-link-manager[data-v-5f4ba43e]{background-color:#ffd966\n}", ""]);

// exports
